<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="loader-container">
    <!-- Lottie player will load the JSON animation placed in public/img/circle-loader.json -->
    <lottie-player
      src="/img/circle-loader.json"
      background="transparent"
      speed="1"
      style="width: 160px; height: 160px;"
      loop
      autoplay
    ></lottie-player>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
.loader {
  height: 100vh;
  width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  .loader-img {
    animation: pulse-new 2s ease infinite;
    margin-top: 40vh;
  }
}
.loader-container {
  width: 100%;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lds-ellipsis {
  margin-bottom: 5vh;
  display: inline-block;
  position: relative;
  width: 60px;
  height: 60px;
}

.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #1476f3;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 7px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 7px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 25px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 49px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(24px, 0);
  }
}

@keyframes pulse-new {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(0.8);
    opacity: 0.3;
  }
}
@media only screen and (max-width: 700px) {
  .loader {
    height: 100vh;
    width: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .loader-img {
      animation: pulse-new 2s ease infinite;
      margin-top: 15vh;
    }
  }
}
</style>
